"use strict";

import angular from "angular";

import { userNameCmp } from "users/utils";

export default function (
  $timeout,
  $scope,
  $http,
  $filter,
  $location,
  toastr,
  Upload,
  pusher,
  userOptions,
) {
  "ngInject";

  const vm = this;
  vm.views = {
    BEATS: "beats",
    BEAT_PHONES: "beat_phones",
    CALL_PROFILES_LEGACY: "call_profiles_legacy",
    DESIGNATIONS: "designations",
    DESIGNATIONS_LEGACY: "designations_legacy",
    ROLES: "roles",
    ESCALATION: "escalation",
    TEAMS: "teams",
    SERVICE_LISTS: "service_lists",
    EVENTS: "events",
    FACILITIES: "facilities",
    API: "api",
    DIGESTS: "digests",
  };
  vm.staffView = userOptions.getStaffView();
  $scope._userOptions = userOptions;
  $scope.$watch(
    "_userOptions.lastUpdated",
    (a, b, c) => {
      vm.staffView = userOptions.getStaffView();
    },
    true,
  );

  vm.updateView = function (view) {
    vm.selectedView = view;
    const s = $location.search();
    if (s.p === view) {
      return;
    }
    $location.search({
      p: view,
      s: s.s,
    });
    // $location.replace()
  };

  vm.getParam = function (k, d, t) {
    const v = $location.search()[k];
    if (v === undefined) {
      return d;
    }
    if (t === "int") {
      return parseInt(v);
    }
    return v;
  };

  vm.setParam = function (k, v) {
    $location.search(k, v);
  };

  vm.scrollTo = function (elementId) {
    const el = document.getElementById(elementId);
    if (!el) return;
    console.log("Scrolling to", el);
    el.scrollIntoView(true, {});
  };

  $scope.$on("$locationChangeSuccess", function (event, newUrl, oldUrl) {
    const _is = $location.search();
    vm.updateView(_is.p || vm.views.DESIGNATIONS);
  });

  vm.dayPixels = 150;
  vm.dayPixelsMax = 440;
  vm.dayPixelsMin = 60;
  vm.dayPixelsDefault = vm.dayPixels;

  vm.displayTime = function (time) {
    if (time == "00:00") return "Midnight";
    if (time == "12:00") return "Noon";
    return time;
  };

  vm.updateDesignationZoom = function (value) {
    console.log(value);
    vm.dayPixels = Math.min(vm.dayPixelsMax, Math.max(vm.dayPixelsMin, value));
  };

  vm.userCreated = function (data) {
    console.log(data);
    toastr.success("", "User created", {
      allowHtml: true,
    });
    _loadData(["roles", "beats"]);
  };

  vm.reserveListsLocked = false;

  function _updateReserveListProfiles(reserve_list) {
    vm.reserveListsLocked = true;
    $http({
      url: "/api/teams/beats/reserve_lists/update_profiles/",
      method: "POST",
      data: {
        reserve_list_id: reserve_list.uuid,
        user_ids: reserve_list.profiles.map((p) => p.user.uuid),
      },
    })
      .then(
        () => {
          toastr.clear();
          toastr.success(`Updated profile order for ${reserve_list.name}.`);
          _loadData(["beats"]);
        },
        () => {
          toastr.error(`Failed to update profile order.`);
        },
      )
      .finally(() => {
        vm.reserveListsLocked = false;
      });
  }

  vm.reserveListTreeOptions = {
    dropped: (e) => {
      $timeout(() => {
        const reserve_list = e.dest.nodesScope.$parent.$parent.reserve_list;
        _updateReserveListProfiles(reserve_list);
      }, 0);
    },
  };

  vm.userListsLocked = false;

  function _moveUserListProfile(profileId, curPosition, newPosition, callback) {
    vm.userListsLocked = true;
    $http({
      url: "/api/flux/user_lists/move_profile/",
      method: "POST",
      data: {
        profile_id: profileId,
        cur_position: curPosition,
        new_position: newPosition,
      },
    })
      .then(
        () => {
          toastr.clear();
          toastr.success(`Updated list order.`);
        },
        () => {
          toastr.error(`Failed to update profile order.`);
        },
      )
      .finally(() => {
        vm.userListsLocked = false;
        if (callback) callback();
      });
  }

  vm.userListTreeOptions = {
    dropped: (e) => {
      $timeout(() => {
        if (e.source.index != e.dest.index) {
          const profile = e.source.nodeScope.$modelValue;
          _moveUserListProfile(profile.id, e.source.index, e.dest.index, () => {
            profile.refetch();
          });
        }
      }, 0);
    },
  };

  vm.data = {};

  function _updateTabs() {
    const escalationTab = vm.escalationTab || 0;
    const facTab = vm.facTab || 0;
    $timeout(() => {
      vm.escalationTab = escalationTab;
      vm.facTab = facTab;
    }, 0);
  }

  _updateTabs();

  let _subscribedToUpdates = false;

  function _receiveAdminUpdate(event, data) {
    console.log(event, data);
    switch (event) {
      case "SERVICE_LIST_UPDATED":
        toastr.success(data.name + " was updated!");
        vm.serviceListUpdating[data.service_list_id] = false;
        break;
      case "SERVICE_ACCOUNTS_CLEANED":
        break;
      default:
        console.error("Unhandled admin update event: " + event);
        break;
    }
  }

  function _loadData(feats) {
    if (vm.loadingData) return;
    vm.loadingData = true;
    $http({
      method: "GET",
      url: "/api/entities/admin/v2?feats=" + feats.join(","),
    })
      .then(
        (result) => {
          vm.now = new Date();
          _updateTabs();
          angular.extend(vm.data, result.data);
          if (feats.indexOf("designations") >= 0) {
            const nextMidnight = new Date();
            nextMidnight.setHours(24, 0, 0, 0);
            vm.tickOffset =
              (nextMidnight.getTime() - vm.now.getTime()) / 1000 / 60 / 60 / 24;
            vm.ticks = [];
            for (let i = 0; i < 60; i++) {
              // This shift by 8 hours accomodates for daylight savings in the US. It is a total hack.
              vm.ticks.push(
                new Date(
                  nextMidnight.getTime() +
                  8 * 60 * 60 * 1000 +
                  i * 24 * 60 * 60 * 1000,
                ),
              );
            }
            vm.designations = result.data.designations.map((designation) => {
              const clonedDesignation = Object.assign({}, designation);
              clonedDesignation.hints = clonedDesignation.hints.map((hint) => {
                const clonedHint = Object.assign({}, hint);
                clonedHint.id = crypto.randomUUID();
                return clonedHint;
              });
              return clonedDesignation;
            });
          }
          if (feats.indexOf("roles") >= 0) {
            // Build list of users, instead of just roles
            vm.users = [];
            vm.data.roles.forEach((role) => {
              role.users.forEach((user) => {
                vm.users.push(user);
              });
            });
            vm.users.sort(userNameCmp);
          }
          vm.entityId = `E-${result.data.entity.uuid}`.toUpperCase();
          if (!_subscribedToUpdates) {
            let channel = pusher.subscribe(
              `presence-entity-${result.data.entity.uuid}-admin`,
            );
            channel.bind_global(_receiveAdminUpdate);
            _subscribedToUpdates = true;
          }
        },
        (error) => {
          console.error(error);
        },
      )
      .finally(() => {
        vm.loadingData = false;
      });
  }

  vm.__loadData = _loadData;

  function _refreshData() {
    _loadData([
      "roles",
      "designations",
      "escalation",
      "beats",
      "events",
      "notify",
      "facilities",
      "api",
      "digests",
    ]);
    $timeout(_refreshData, 30 * 60 * 1000);
  }

  vm.__refreshData = _refreshData;

  _refreshData();

  vm.escalationUserCreated = function (profile) {
    const minutes = Math.floor(profile.start_seconds / 60);
    const content = `
		We will now call <b>${profile.user.first_name}</b>
		after <b>${minutes} minutes</b> when using engaging the
		<b>${profile.escalation_tree.name}</b> tree.
		`;
    toastr.success(content, "Escalation profile created", {
      allowHtml: true,
    });
    _loadData(["escalation"]);
  };

  vm.eventStakeholderAdded = function () {
    toastr.success("Stakeholder added");
    _loadData(["events"]);
  };

  vm.escalationProfileDeleted = function (result) {
    console.log(result);
    const message = `
		We will no longer call ${result.context.displayName} after ${result.context.startMinutes} minutes.
		`;
    toastr.success(message, `${result.context.treeName} profile deleted`, {
      allowHtml: true,
    });
    _loadData(["escalation"]);
  };

  vm.lockScheduleBars = true;
  const _scheduleBars = [];
  vm.updateScheduleBars = function () {
    for (const el of document.getElementsByClassName(
      "designation-schedule-bar",
    )) {
      if (!el.onscroll) {
        _scheduleBars.push(el);
        el.onscroll = function (e) {
          if (!vm.lockScheduleBars) return;
          for (const bar of _scheduleBars) {
            if (bar === el) continue;
            bar.scrollLeft = el.scrollLeft;
          }
        };
      }
    }
  };

  vm.bulkAssignee = {};
  vm.bulkAssigneeSelected = function (data) {
    // data = { designation, user, phoneNumber }
    if (data.designation == "all") vm.bulkAssignee.all = data;
    else vm.bulkAssignee[data.designation.uuid] = data;
  };

  function _scheduleAssignee(designation, assignee, localizations) {
    $http({
      method: "POST",
      url: "/api/entities/admin/v2/schedule_designation_profile",
      data: {
        designation: designation.uuid,
        user: assignee.user.uuid,
        phone_number: assignee.phoneNumber,
        date_start: localizations.date_start,
        time_start: localizations.time_start,
        date_end: localizations.date_end,
        time_end: localizations.time_end,
        tzstr: vm.data.timezone,
      },
    }).then(
      (response) => {
        vm.designationProfileScheduled(response.data);
      },
      (error) => {
        if (error.status >= 500) toastr.error("An unexpected error occurred");
      },
    );
  }

  function _cleanLocs(checkDate, loc) {
    const _copy = angular.copy(loc);
    if (new Date(checkDate) < new Date()) {
      delete _copy.date_start;
      delete _copy.time_start;
    }
    return _copy;
  }

  vm.scheduleAssigneeByBlock = function (designation, assignee, block) {
    _scheduleAssignee(
      designation,
      assignee,
      _cleanLocs(block.date_start, block.localizations),
    );
  };

  vm.scheduleAssigneeByHint = function (designation, assignee, hint) {
    _scheduleAssignee(
      designation,
      assignee,
      _cleanLocs(hint.date_start, hint.localizations),
    );
  };

  // designation uuid => list of scheduled profiles in this session
  vm.recentlyScheduledProfiles = {};

  vm.unscheduleLastProfile = function (designationId) {
    const profiles = vm.recentlyScheduledProfiles[designationId];
    const profileData = profiles.shift();
    const message =
      `Are you sure you want to unschedule ` +
      `${profileData.user.first_name} as ${profileData.designation.name}?`;
    if (confirm(message)) {
      $http({
        method: "POST",
        url: "/api/entities/admin/v2/delete_scheduled_profile",
        data: {
          profile_uuid: profileData.uuid,
        },
      }).then(
        () => {
          toastr.success(`
					Unscheduled ${profileData.user.first_name} as ${profileData.designation.name}.
					`);
          _loadData(["designations", "escalation"]);
        },
        () => {
          toastr.error("Unable to unschedule.");
          profileData.unshift(profileData);
        },
      );
    }
  };

  vm.designationProfileScheduled = function (newData) {
    const dateStartDisplay = $filter("date")(newData.date_start, "M/d, h:mm a");
    const dateEndDisplay = $filter("date")(newData.date_end, "M/d, h:mm a");
    const title = `Scheduled <b>${newData.user.first_name}</b> as <b>${newData.designation.name}</b>`;
    const content = `<div>${dateStartDisplay} &mdash; ${dateEndDisplay}.</div>`;

    newData.timeCreated = new Date();
    if (!vm.recentlyScheduledProfiles[newData.designation.uuid]) {
      vm.recentlyScheduledProfiles[newData.designation.uuid] = [];
    }
    vm.recentlyScheduledProfiles[newData.designation.uuid].unshift(newData);

    toastr.success(content, title, {
      allowHtml: true,
      timeOut: 5 * 1000,
    });
    _loadData(["designations", "escalation"]);
  };

  vm.beatPhoneCreated = function (beat) {
    toastr.success(`Phone created.`);
    _loadData(["roles"]);
  };

  vm.deleteBeatPhone = function (user, phone) {
    if (
      confirm(`Are you sure you want to delete this phone number for ${user.first_name}? 

This action cannot be undone.
			`)
    ) {
      $http({
        method: "POST",
        url: "/api/teams/beats/delete_phone/",
        data: {
          phone_id: phone.uuid,
        },
      }).then(
        () => {
          toastr.success(`Phone deleted.`);
          _loadData(["roles"]);
        },
        (error) => {
          toastr.error("Unable to delete phone.");
        },
      );
    }
  };

  vm.beatReserveListCreated = function (reserve_list) {
    toastr.success(`${reserve_list.name} created.`);
    _loadData(["beats"]);
  };

  vm.beatCreated = function (beat) {
    toastr.success(`${beat.name} created.`);
    _loadData(["beats"]);
  };

  vm.deleteReserveList = function (reserve_list) {
    if (confirm(`Are you sure you want to delete ${reserve_list.name}`)) {
      $http({
        method: "POST",
        url: "/api/teams/beats/reserve_lists/delete/",
        data: {
          reserve_list_id: reserve_list.uuid,
        },
      }).then(
        () => {
          toastr.success(`Deleted ${reserve_list.name}.`);
          _loadData(["beats"]);
        },
        (error) => {
          if (error.data.message) {
            toastr.error(error.data.message);
          } else {
            toastr.error("Unable to delete reserve list.");
          }
        },
      );
    }
  };

  vm.deprecateBeat = function (beat) {
    if (confirm(`Are you sure you want to archive ${beat.name}`)) {
      $http({
        method: "POST",
        url: "/api/teams/beats/deprecate/",
        data: {
          beat_id: beat.uuid,
        },
      }).then(
        () => {
          toastr.success(`Archived ${beat.name}.`);
          _loadData(["beats"]);
        },
        () => {
          toastr.error("Unable to archive beat.");
        },
      );
    }
  };

  vm.updateBeatReserveList = function (beat, reserve_list) {
    const oldReserveList = beat.reserve_list;
    beat._reserve_list = reserve_list;
    const data = {
      beat_id: beat.uuid,
    };
    if (reserve_list) data.reserve_list_id = reserve_list.uuid;
    $http({
      method: "POST",
      url: "/api/teams/beats/update_reserve_list/",
      data: data,
    }).then(
      () => {
        const message = `Updated reserve list for ${beat.name}.`;
        toastr.success(message);
      },
      () => {
        toastr.error("Unable to save reserve list");
        beat._reserve_list = oldReserveList;
      },
    );
  };

  vm.beatCallProfileCreated = function (response) {
    console.log(response);
    toastr.success("User added to beat");
    _loadData(["beats"]);
  };

  vm.reserveProfileAppended = function (response) {
    toastr.success("User added to reserve list.");
    _loadData(["beats"]);
  };

  vm.deleteBeatReserveProfile = function (reserve_list, profile) {
    if (
      confirm(
        `Are you sure you want to remove ${profile.user.first_name} from ${reserve_list.name}?`,
      )
    ) {
      $http({
        method: "POST",
        url: "/api/teams/beats/reserve_lists/delete_profile/",
        data: {
          reserve_profile_id: profile.uuid,
        },
      }).then(
        () => {
          toastr.success(
            `${profile.user.first_name} removed from ${reserve_list.name}.`,
          );
          _loadData(["beats"]);
        },
        () => {
          toastr.error("Unable to remove profile.");
        },
      );
    }
  };

  vm.deleteBeatCallProfile = function (beat, profile) {
    if (
      confirm(
        `Are you sure you want to remove ${profile.user.first_name} from ${beat.name}?`,
      )
    ) {
      $http({
        method: "POST",
        url: "/api/teams/beats/call_profiles/delete/",
        data: {
          call_profile_id: profile.uuid,
        },
      }).then(
        () => {
          const message = `${profile.user.first_name} removed from ${beat.name}.`;
          toastr.success(message);
          _loadData(["beats"]);
        },
        () => {
          toastr.error("Unable to remove profile.");
        },
      );
    }
  };

  vm.updateReserveListNotes = function (reserve_list, notes) {
    const oldNotes = reserve_list.notes;
    reserve_list._notes_saving = true;
    $http({
      method: "POST",
      url: "/api/teams/beats/reserve_lists/update_notes/",
      data: {
        reserve_list_id: reserve_list.uuid,
        body: notes,
      },
    })
      .then(
        () => {
          const message = `Updated notes for ${reserve_list.name}.`;
          reserve_list.notes = notes;
          reserve_list.notes_last_updated_by = "you";
          toastr.success(message);
        },
        () => {
          toastr.error("Unable to save notes");
          reserve_list.notes = oldNotes;
        },
      )
      .finally(() => {
        reserve_list._notes_saving = false;
      });
  };

  vm.updateReserveListCalloutSettings = function (
    reserve_list,
    call_method,
    target_call_count,
  ) {
    const oldCallMethod = reserve_list.call_method;
    const oldCallCount = reserve_list.target_call_count;
    reserve_list.call_method = call_method;
    reserve_list.target_call_count = target_call_count;
    $http({
      method: "POST",
      url: "/api/teams/beats/reserve_lists/update_callout_settings/",
      data: {
        reserve_list_id: reserve_list.uuid,
        call_method: call_method,
        target_call_count: target_call_count,
      },
    }).then(
      () => {
        const message = `Updated ${reserve_list.name} callout settings.`;
        toastr.success(message);
      },
      () => {
        toastr.error("Unable to update callout settings");
        reserve_list.call_method = oldCallMethod;
        reserve_list.target_call_count = oldCallCount;
      },
    );
  };

  vm.serviceListUpdating = {};

  vm.uploadFacilitySpreadsheet = function (spreadsheet) {
    Upload.upload({
      url: "/api/admin/facilities/upload_spreadsheet/",
      method: "POST",
      data: {
        spreadsheet: spreadsheet,
      },
    }).then(
      () => {
        toastr.success("Facilities list updated.");
        _refreshData(["facilities"]);
      },
      (error) => {
        if (error.data.spreadsheet) {
          alert(error.data.spreadsheet);
        } else {
          alert("An unexpected error occurred (code: FAC-SPR-01)");
        }
      },
    );
  };

  vm.uploadFluxAccounts = function (spreadsheet) {
    Upload.upload({
      url: "/api/flux/accounts/add_by_spreadsheet/",
      method: "POST",
      data: {
        spreadsheet: spreadsheet,
      },
    }).then(
      () => {
        toastr.success("Processing accounts spreadsheet.");
        _refreshData(["notify"]);
      },
      (error) => {
        console.error(error);
        if (error.data) {
          alert(error.data);
        } else {
          alert("An unexpected error occurred (code: ACC-SPR-01)");
        }
      },
    );
  };

  vm.uploadServiceListSpreadsheet = function (serviceListId, spreadsheet) {
    Upload.upload({
      url: "/api/citizen_engagement/service_lists/upload_spreadsheet/",
      method: "POST",
      data: {
        service_list_id: serviceListId,
        spreadsheet: spreadsheet,
      },
    }).then(
      () => {
        vm.serviceListUpdating[serviceListId] = true;
      },
      (error) => {
        if (error.data.spreadsheet) {
          alert(error.data.spreadsheet);
        } else {
          alert("An unexpected error occurred (code: USL-SPR-01)");
        }
      },
    );
  };

  vm.removeServiceListItem = function (serviceListId, itemId) {
    if (confirm("Are you sure you want to remove this item?")) {
      vm.serviceListUpdating[serviceListId] = true;
      $http({
        url: "/api/citizen_engagement/service_lists/remove_item/",
        method: "POST",
        data: { item_id: itemId },
      }).then(() => {
        vm.serviceListUpdating[serviceListId] = true;
      });
    }
  };

  vm.undoLastServiceListUpdate = function (serviceList) {
    if (
      confirm(
        "Are you sure you want to undo the last update?\nThis action cannot be undone.",
      )
    ) {
      vm.serviceListUpdating[serviceList.uuid] = true;
      $http({
        url: "/api/citizen_engagement/service_lists/undo_latest_update/",
        method: "POST",
        data: { list_id: serviceList.uuid },
      })
        .then(() => {
          // toastr.success('The last action was reversed.')
        })
        .finally(() => {
          vm.serviceListUpdating[serviceList.uuid] = false;
        });
    }
  };

  const _lduh = {};
  vm.legacyDesignationUpdateHandler = function (name) {
    if (!_lduh[name]) {
      _lduh[name] = {
        onSuccess: () => {
          vm.legacy.designatedUserQuery.reload();
          if (vm.legacy.callProfilesQuery) vm.legacy.callProfilesQuery.reload();
          toastr.success(name + " was updated.");
        },
      };
    }
    return _lduh[name];
  };

  vm.createIncidentDigestSubscription = function (user, optionsId) {
    vm.digestUpdating = true;
    $http({
      url: "/api/admin/incidents/create_digest_subscription/",
      method: "POST",
      data: {
        user_id: user.uuid,
        options_id: optionsId || null,
      },
    }).then(() => {
      _loadData(["digests"]);
      vm.digestUpdating = false;
      toastr.success(`${user.first_name} is now subscribed.`);
    });
  };

  vm.deleteIncidentDigestSubscription = function (sub) {
    vm.digestUpdating = true;
    $http({
      url: "/api/admin/incidents/delete_digest_subscription/",
      method: "POST",
      data: { subscription_id: sub.id },
    }).then(() => {
      _loadData(["digests"]);
      vm.digestUpdating = false;
      toastr.success(`${sub.user.first_name} was unsubscribed.`);
    });
  };

  vm.hourToTime = function (hour) {
    hour = hour < 24 ? hour : 0;
    const h = Math.floor(hour);
    const m = Math.floor((hour - h) * 60);
    const l = m < 10 ? "0" : "";
    const a = h < 12 ? "AM" : "PM";
    return `${h}:${l}${m} ${a}`;
  };

  vm.parseFileContents = function (file, target, converter) {
    const reader = new FileReader();
    target.state = "loading";
    reader.onload = function (event) {
      target.state = "done";
      $timeout(() => {
        const contents = event.target.result;
        if (converter === "json") {
          try {
            target.contents = JSON.parse(contents);
          } catch (e) {
            target.state = "error";
            target.error = e.message;
          }
        } else {
          target.contents = contents;
        }
      }, 0);
    };
    reader.onerror = function (event) {
      target.state = "error";
      target.error = event.target.error.message;
      console.error("File could not be read! " + event.target.error.message);
    };
    if (file) {
      reader.readAsText(file);
    }
  };

  vm.getRolesForDisplay = function (isStaff) {
    if (!vm.data.roles) {
      return [];
    }
    if (isStaff) {
      return vm.data.roles;
    }
    return vm.data.roles.filter(
      ({ display_name }) => !display_name.startsWith("_"),
    );
  };

  vm.getUsersForRole = function (role) {
    return role.users
      .filter(({ is_active }) => is_active)
      .sort((l, r) => l.last_name.localeCompare(r.last_name, "en"));
  };

  vm.getInactiveUsersForRole = function (role) {
    return role.users
      .filter(({ is_active }) => !is_active)
      .sort((l, r) => l.last_name.localeCompare(r.last_name, "en"));
  };

  vm.hasWorkStatuses = function (rolesQuery) {
    if (!rolesQuery.data.workStatuses) {
      return false;
    }
    return rolesQuery.data.workStatuses.length > 0;
  };

  vm.buildHolidaysObserved = function (entityWithGenericHolidays) {
    return entityWithGenericHolidays.genericHolidaysSlow.reduce((acc, gh) => {
      acc[gh.canonicalName] = gh;
      return acc;
    }, {});
  }

  vm.buildObservedHolidayMap = function (entityWithSchedulingData) {
    return entityWithSchedulingData.genericHolidaysSlow.reduce((acc, gh) => {
      acc[gh.canonicalName] = gh.observed;
      return acc;
    }, {});
  }

  vm.buildNewConfig = function (entityWithSchedulingData, holidayMap) {
    const currentConfig = entityWithSchedulingData.holidayConfig;
    const newObservedHolidays = entityWithSchedulingData.genericHolidaysSlow.filter((h) => holidayMap[h.canonicalName]).map((h) => {
      return {
        display_name: h.displayName,
      };
    });
    return Object.assign({}, currentConfig, {
      observed_holidays: newObservedHolidays,
    });
  }
}
